import { useCallback, useState } from "react";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import { TDepartamentosEstoque } from "../../../../../types/api/estoque/departamentos-estoque";
import DialogCriacaoEditDepartamentos from "./DialogCriacaoEditDepartamentos";

export default function Departamentos() {

  const [openModal, setOpenModal] = useState<TOpenModalDepartamento>(null)

  //funções manipuladoras
  const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TDepartamentosEstoque | null) => {
    if (action === "close") setOpenModal(null)
    if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
    if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
  }, [])
  //

  return (
    <>
      <SessaoConfiguracao<TDepartamentosEstoque>
        titulo="Departamentos"
        endpoints={{
          listar: "estoque/pesquisar-departamentos",
          deletar: "estoque/configuracoes/excluir-departamento",
        }}
        colunas={colunas}
        queryKey="pesquisar-departamentos"
        onEditar={(departamento) => {
          handleModalAction("open", departamento.id, departamento)
        }}
        onAdicionar={() => {
          handleModalAction("open", true, null)
        }}
        mensagemSucessoDeletar="Departamento deletado com sucesso!"
        mensagemErroDeletar="Erro ao deletar departamento!"
        mensagemSemDados="Nenhum departamento encontrado."
      />

      {Boolean(openModal?.open) && (
        <DialogCriacaoEditDepartamentos
          open={Boolean(openModal?.open)}
          handleClose={() => {
            handleModalAction("close")
          }}
          defaultValue={openModal?.defaultValue ? openModal : null}
        />
      )}
    </>
  );
}

export type TOpenModalDepartamento = {
  open: number | boolean | null;
  defaultValue: TDepartamentosEstoque | null;
} | null

const colunas: ConfiguracaoColunas<TDepartamentosEstoque>[] = [
  {
    campo: "nome",
    titulo: "Nome",
  },
];
